;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/news/:category\",\"regex\":\"^/news/([^/]+)$\",\"paramNames\":[\"category\"],\"hasOptionalPrefix\":false},{\"path\":\"/news/:category/:slug\",\"regex\":\"^/news/([^/]+)/([^/]+)$\",\"paramNames\":[\"category\",\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/news\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs'

import { getPublicEnv } from '@/shared/env'

const runtimeEnv = getPublicEnv()

Sentry.init({
    dsn: runtimeEnv.NEXT_PUBLIC_SENTRY_DSN,
    environment: runtimeEnv.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: runtimeEnv.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE,

    integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],

    ignoreErrors: ['Failed to connect to MetaMask', 'Error invoking postMessage: Java object is gone'],
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
